/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import { useEffect } from "react";
import { Link } from "react-router-dom";

import { useEventCommunicator } from "@/v2/hooks/useEventCommunicator";
import { useInIframe } from "@/v2/hooks/useInIframe";

import {
  CaretDownIcon,
  CaretUpIcon,
  CloseIcon,
  ExternalLinkIcon,
} from "../../../../v1/components/atoms/Icons";
import Tooltip from "../../../../v1/components/atoms/Tooltip";
import { useTranslation } from "../../../hooks/useTranslation";
import { useTasksQueryByLastDay } from "../../../query/useTasksQueryByLastDay/useTasksQueryByLastDay";
import { useTaskManagerStore, WidgetState } from "../../../store/useTaskManagerStore";
import { isEmpty } from "../../../utils/isEmpty";

import { StatusHeader } from "./components/templates/StatusHeader/StatusHeader";
import { TaskList } from "./components/templates/TaskList/TaskList";
import { isAllTasksCompleted } from "./utils/isAllTasksCompleted";
import { useTaskManagerWidget } from "./useTaskManagerWidget";

import "./TaskManagerWidget.scss";

const TaskManagerWidget = () => {
  const { widgetState, setWidgetState, taskList, setUpdated, updated, completed, setCompleted } =
    useTaskManagerStore();
  const { setWidgetClasses, toggleWidget, hideWidget, isExpanded, isCollapsed } =
    useTaskManagerWidget();
  const { data } = useTasksQueryByLastDay();
  const { t } = useTranslation();
  const isInIframe = useInIframe();
  const { eventEmitter } = useEventCommunicator();

  useEffect(() => {
    if (isAllTasksCompleted(data || [])) return setCompleted(true);
    setCompleted(false);
    setUpdated(true);
    setTimeout(() => {
      setUpdated(false);
    }, 2500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (isEmpty(taskList)) return;
    eventEmitter({ type: "TASK_MANAGER_UPDATE" });
    if (isCollapsed(widgetState)) return;
    setWidgetState(WidgetState.expanded);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskList]);

  if (isInIframe) return null;

  return (
    <section className={`${setWidgetClasses(widgetState, updated, completed)}`}>
      <header className="task-manager-widget__header">
        <p className="task-manager-widget__status">{data && <StatusHeader tasks={data} />}</p>
        <div className="task-manager-widget__actions">
          <Tooltip message={t("label.open-tasks-page")}>
            <Link className="action" to="/my-tasks">
              <ExternalLinkIcon />
            </Link>
          </Tooltip>
          <Tooltip message={isExpanded(widgetState) ? t("label.collapse") : t("label.expand")}>
            <button
              data-testid="toggle-button"
              className="action"
              onClick={() => toggleWidget(widgetState, setWidgetState)}
            >
              {isExpanded(widgetState) ? <CaretDownIcon /> : <CaretUpIcon />}
            </button>
          </Tooltip>
          <Tooltip message={t("label.close")}>
            <button
              data-testid="close-button"
              className="action"
              onClick={() => hideWidget(setWidgetState)}
            >
              <CloseIcon />
            </button>
          </Tooltip>
        </div>
      </header>
      <div className="task-manager-widget__tasks">{data && <TaskList tasks={data} />}</div>
    </section>
  );
};

export default TaskManagerWidget;
